import { h } from 'preact'
import { useContext } from 'preact/hooks'
import cls from 'classnames'
import styles from './index.scss'
import BaseContext from 'contexts/base-context'

type Props = {
  code?: string
  isHero?: boolean
}

const Highlight = ({ code, isHero = false }: Props) => {
  const { editingCode } = useContext(BaseContext)!
  const isHighlight = code !== undefined && editingCode === code
  return (
    <div
      className={cls(
        {
          [styles.highlightHero]: isHero,
        },
        isHighlight ? styles.highlightActive : styles.highlightDefault
      )}
    />
  )
}

export default Highlight
